module.exports = __webpack_public_path__ + "img/logo.d00319c4.jpg";